import { useIntl } from "react-intl";

import { cn } from "tools/ui";
import { SERVICE_ICONS, STYLE_FOCUS_RING } from "../constants";

function IconPicker({ value, onChange }) {
  const intl = useIntl();
  return (
    <div className="flex flex-wrap gap-2">
      {SERVICE_ICONS.map(({ value: name, label, Icon }) => {
        const selected = value === name;
        const title = intl.formatMessage({ id: label });
        return (
          <button
            key={name}
            type="button"
            title={title}
            aria-label={title}
            aria-pressed={selected}
            onClick={() => onChange(selected ? "" : name)}
            className={cn(
              "flex size-11 items-center justify-center rounded-md border transition-colors",
              selected
                ? "border-sky-950 bg-sky-950 text-white"
                : "border-neutral-300 bg-white text-neutral-600 hover:border-sky-900",
              STYLE_FOCUS_RING,
            )}
          >
            <Icon width={20} className="fill-current" />
          </button>
        );
      })}
    </div>
  );
}

export default IconPicker;
